import React from 'react';
import { Users, Gift, TrendingUp } from 'lucide-react';
import { Card } from './ui/card';

const Referral = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Earn Up To <span className="text-[#40E095]">1TB Free Storage</span>
              </h2>
              <p className="text-lg text-gray-600">
                Share Drivault with friends and family. When they sign up and start using it, 
                you both get bonus storage. It's our way of saying thank you.
              </p>
            </div>

            {/* Referral Stats */}
            <div className="grid sm:grid-cols-3 gap-6">
              <Card className="p-6 text-center border-2 border-gray-100 hover:border-[#40E095]/50 transition-all hover:shadow-lg">
                <Users className="text-[#40E095] mx-auto mb-3" size={36} />
                <p className="text-3xl font-bold text-gray-900 mb-1">9</p>
                <p className="text-sm text-gray-600">Max Invites</p>
              </Card>

              <Card className="p-6 text-center border-2 border-gray-100 hover:border-[#40E095]/50 transition-all hover:shadow-lg">
                <Gift className="text-[#40E095] mx-auto mb-3" size={36} />
                <p className="text-3xl font-bold text-gray-900 mb-1">100GB</p>
                <p className="text-sm text-gray-600">Per Referral</p>
              </Card>

              <Card className="p-6 text-center border-2 border-gray-100 hover:border-[#40E095]/50 transition-all hover:shadow-lg">
                <TrendingUp className="text-[#40E095] mx-auto mb-3" size={36} />
                <p className="text-3xl font-bold text-gray-900 mb-1">1TB</p>
                <p className="text-sm text-gray-600">Total Bonus</p>
              </Card>
            </div>

            {/* How It Works */}
            <div className="bg-[#40E095]/5 rounded-2xl p-6 space-y-4">
              <h3 className="text-xl font-bold text-gray-900 mb-4">How It Works</h3>
              
              <div className="flex items-start space-x-4">
                <div className="bg-[#40E095] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold flex-shrink-0">
                  1
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Get Your Unique Link</h4>
                  <p className="text-gray-600 text-sm">Access your personal referral link from your dashboard</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="bg-[#40E095] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold flex-shrink-0">
                  2
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Share With Friends</h4>
                  <p className="text-gray-600 text-sm">Send your link to up to 9 friends or family members</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="bg-[#40E095] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold flex-shrink-0">
                  3
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Both Get Bonus Storage</h4>
                  <p className="text-gray-600 text-sm">When they sign up and use Drivault, you both get 100GB free</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1515169067868-5387ec356754" 
                alt="Share with friends" 
                className="w-full h-auto"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#40E095]/20 to-transparent"></div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-2xl p-6 max-w-xs">
              <p className="text-sm text-gray-600 mb-2">Current Bonus</p>
              <p className="text-3xl font-bold text-[#40E095]">+1TB</p>
              <p className="text-xs text-gray-500 mt-1">Available free storage</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Referral;
